import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UploadRequestControllerService} from '../../services/upload-request-controller.service';

@Component({
  selector: 'app-protocol-dialog',
  templateUrl: './protocol-dialog.component.html',
  styleUrls: ['./protocol-dialog.component.css']
})

export class ProtocolDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ProtocolDialogComponent>,
    private uploadRequestControllerService: UploadRequestControllerService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit(): void {
    this.uploadRequestControllerService.protocolUsingGET(this.data['id']).subscribe(protocol => {
      console.error(protocol);
    });
  }

  confirm(result) {
    this.dialogRef.close(result);
  }

}

export interface DialogData {
  type: string;
}
